import { useToggle } from 'react-use'
import { useKycStatusOnboarding } from 'shared/kyc-onboarding'
import { type KYC } from 'shared/types'

import { useGetHome } from '~/domains/home-v2/shared/hooks/get-bff'
import { type Entity, type Subject } from '~/domains/platform/infra/deus-ex-machina/types'
import { Choose, If } from '~/domains/platform/lib/utilities-components'

import { BalanceCard } from './components/balance-card.component'
import { MainMenu } from './components/main-menu.component'
import { SidebarActionButtonSwitchAccount, SidebarSwitchAccount } from './components/switch-account.component'
import { TeamRoleBar } from './components/team-role-bar.component'

export function Sidebar({
  entity,
  subject
}: {
  entity: Entity<'acquirer' | 'banking'>
  subject: Subject<'stone_account_resources' | 'stone_account_kyc'>
}) {
  const [isSwappingAccount, toggleSwappingAccount] = useToggle(false)
  const kycStatus = entity.kycStatus as Exclude<KYC, 'blocked'>
  const { kycStatusPending } = useKycStatusOnboarding(
    subject.id,
    kycStatus,
    subject.kycRequest?.reason,
    entity,
    subject
  )

  const { teamRoleBar } = useGetHome({
    document: subject?.document,
    accountId: entity?.paymentAccount?.id,
    globalId: entity.id,
    affiliationKey: entity?.stoneCodes[0]?.affiliationKey,
    stoneAccount: entity?.stoneAccount
  })

  return (
    <Choose>
      <Choose.When condition={isSwappingAccount}>
        <SidebarSwitchAccount entity={entity} subject={subject} callback={toggleSwappingAccount} />
      </Choose.When>
      <Choose.Otherwise>
        <SidebarActionButtonSwitchAccount entity={entity} callback={toggleSwappingAccount} />
        <If condition={!kycStatusPending}>
          <TeamRoleBar teamRoleBar={teamRoleBar} />
          <BalanceCard entity={entity} subject={subject} withTopDivider={!teamRoleBar?.show} />
          <MainMenu entity={entity} subject={subject} />
        </If>
      </Choose.Otherwise>
    </Choose>
  )
}
